import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private http: HttpClient) {}

    get token(): string | null {
        return localStorage.getItem('token');
    }

    set token(value: string) {
        localStorage.setItem('token', value);
    }

    get user(): any {
        return localStorage.getItem('user');
    }

    set user(value: string) {
        localStorage.setItem('user', value);
    }

    login(formulario: any): Observable<any> {
        return this.http.post(`${environment.apiBack}login`, formulario);
    }

    isLoggedIn() {
        return localStorage.getItem('token') !== null;
    }

    clearSession(): void {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('plan_activo');
    }

    sendResetCode(email: string): Observable<any> {
        return this.http.post(`${environment.apiBack}password/send-code`, { email });
    }

    verifyResetCode(email: string, code: string): Observable<any> {
        return this.http.post(`${environment.apiBack}password/verify-code`, { email, code });
    }

    resetPassword(data: { email: string; code: string; password: string; password_confirmation: string }): Observable<any> {
        return this.http.post(`${environment.apiBack}password/reset`, data);
    }

    sendRegisterCode(email: string): Observable<any> {
        return this.http.post(`${environment.apiBack}register/send-code`, { email });
    }

    verifyRegisterCode(email: string, code: string): Observable<any> {
        return this.http.post(`${environment.apiBack}register/verify-code`, { email, code });
    }

    verifyCompanyCode(company_code: string): Observable<any> {
        return this.http.get(`${environment.apiBack}entidades/codigo/${company_code}`);
    }

    verifySedeCode(sede_code: string): Observable<any> {
        return this.http.get(`${environment.apiBack}sedes/codigo/${sede_code}`);
    }

    register(data: {
        identificacion: string;
        nombres: string;
        apellidos: string;
        email: string;
        celular: string;
        fecha_nacimiento: string | null;
        genero: string | null;
        tipo_colaborador?: string | null;
        password: string;
        entidad_id: number;
        tipo_documento_id: number;
        role: string;
        sede_id?: number;
        acepta_terminos: boolean;
        acepta_tratamiento_datos: boolean;
        acepta_politica_privacidad: boolean;
        acepta_datos_biometricos?: boolean;
        acepta_geolocalizacion?: boolean;
    }): Observable<any> {
        return this.http.post(`${environment.apiBack}register`, data);
    }

    logout() {
        // 1. Primero obtenemos el token
        const token = localStorage.getItem('token');

        // 2. Configuramos los headers
        const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        });

        // 3. Hacemos la petición con los headers
        return this.http.post(`${environment.apiBack}logout`, {}, { headers }).pipe(
            finalize(() => {
                // 4. Solo eliminamos los datos del localStorage después de una respuesta exitosa
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('plan_activo');
            })
        );
    }
}
